import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import JSZip from "jszip";
import Loader from "../../components/Loader/loader";

const SendMailWithPdf = ({ relocation_id, email, Quotation, first_name, setShowEmailModalPayLink, lead_owner }) => {
  const closeModalLink = () => setShowEmailModalPayLink(false);
  const baseAPI = process.env.REACT_APP_API_URL;
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const [emailDataPayLink, setEmailDataPayLink] = useState({
    mail_to: "",
    mail_subject: "",
    mail_body: "",
    Payment_requested: "",
    charges_per: "0",
    paymentgatewayCharges: "",
    total_payment: "",
    remark: "",
    document_path: "",
    doc_name: "",
    lead_owner: lead_owner || "",
  });

  const recalculateTotals = (paymentRequested, chargesPer) => {
    const gatewayCharges = (paymentRequested * chargesPer) / 100;
    const totalPayment = paymentRequested + gatewayCharges;
    return {
      paymentgatewayCharges: gatewayCharges.toFixed(2),
      total_payment: totalPayment.toFixed(2),
    };
  };

  useEffect(() => {
    if (relocation_id || email || Quotation || first_name || lead_owner) {
      const subject = `Carry My Pet // Payment Link for Your Booking - Lead ID :${relocation_id} || ${first_name}`;
      const paymentRequested = parseFloat(Quotation) || 0;
      const chargesPer = parseFloat(emailDataPayLink.charges_per) || 0;
      const { paymentgatewayCharges, total_payment } = recalculateTotals(paymentRequested, chargesPer);

      setEmailDataPayLink((prev) => ({
        ...prev,
        mail_to: email,
        Payment_requested: paymentRequested,
        mail_subject: subject,
        paymentgatewayCharges,
        total_payment,
        lead_owner: lead_owner || "",
      }));

      getMailTemplate();
    }
  }, [relocation_id, email, Quotation, first_name]);

  const getMailTemplate = async () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    try {
      const res = await axios.get(
        `${baseAPI}userget/GetEmailTemplate?mail_template_id=2&options=null`,
        { headers: { Authorization: `Bearer ${storedToken}` } }
      );

      if (res.data?.data) {
        const subject = `Carry My Pet // Payment Link for Your Booking - Lead ID :${relocation_id} || ${first_name}`;
        setEmailDataPayLink((prev) => ({
          ...res.data.data,
          mail_to: email,
          Payment_requested: Quotation,
          mail_subject: subject,
        }));
      }
    } catch (err) {
      console.error("Error fetching email template:", err);
    }
  };

  const getUpdatedImage = (file, name) => {
    setEmailDataPayLink((prev) => ({ ...prev, [name]: file }));
  };

  const isValidFileType = (file) => {
    const allowedTypes = [
      "image/jpeg", "image/png", "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel", "video/mp4", "video/x-msvideo",
      "video/x-matroska", "video/quicktime", "application/zip",
      "application/x-zip-compressed",
    ];
    return file && allowedTypes.includes(file.type);
  };

  const validateZipFile = (file, name, e) => {
    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const zip = await new JSZip().loadAsync(event.target.result);
        const allowedExtensions = ["jpg", "png", "pdf", "docx", "xlsx"];
        let isValid = true;

        zip.forEach((path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (!allowedExtensions.includes(ext)) isValid = false;
        });

        if (isValid) {
          getUpdatedImage(file, name);
        } else {
          toast.error("ZIP file contains unsupported file types.");
          e.target.value = null;
        }
      } catch (error) {
        toast.error("Error reading ZIP file.");
        e.target.value = null;
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleChangeDoc = (e) => {
    const { name, files } = e.target;
    const file = files[0];

    if (file.size > 50 * 1024 * 1024) {
      toast.error("File size exceeds 50 MB limit.");
      e.target.value = null;
      return;
    }

    if (isValidFileType(file)) {
      if (file.type.includes("zip")) validateZipFile(file, name, e);
      else getUpdatedImage(file, name);
    } else {
      toast.error("Unsupported file type. Please upload a valid file.");
      e.target.value = null;
    }
  };

  const SavePdfSendMail = async () => {
    if (!emailDataPayLink.doc_name) return toast.error("Please upload a document.");
    if (!emailDataPayLink.Payment_requested) return toast.error("Please enter the requested payment.");

    setLoading(true); // Start loader

    // Let React render the loader before continuing heavy logic
    setTimeout(async () => {
      try {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        const formData = new FormData();

        const total_payment = Number(emailDataPayLink.total_payment) || Number(Quotation);
        const remark = emailDataPayLink.remark || "0";

        const paymentResponse = await axios.post(
          `${baseAPI}Payment/GeneratePaymentLinkRazorpay`,
          { relocation_id, total_payment, remark },
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        formData.append("relocation_id", relocation_id);
        formData.append("paymentLink", paymentResponse.data?.data || "");
        formData.append("mail_to", emailDataPayLink.mail_to);
        formData.append("mail_body", emailDataPayLink.mail_body);
        formData.append("mail_subject", emailDataPayLink.mail_subject);
        formData.append("Payment_requested", emailDataPayLink.Payment_requested);
        formData.append("charges_per", emailDataPayLink.charges_per);
        formData.append("paymentgatewayCharges", emailDataPayLink.paymentgatewayCharges);
        formData.append("total_payment", emailDataPayLink.total_payment);
        formData.append("pdfFile", emailDataPayLink.doc_name);
        formData.append("remark", emailDataPayLink.remark);
        formData.append("lead_owner", emailDataPayLink.lead_owner);

        await axios.post(`${baseAPI}userpost/SavePdfSendPayLinkRazorpay`, formData, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "multipart/form-data",
          },
        });

        toast.success("Mail Sent Successfully!");
        setTimeout(() => {
          if (typeof closeModalLink === "function") closeModalLink();
        }, 2000);
      } catch (error) {
        console.error("Error:", error);
        toast.error("Failed to send mail. Please try again.");
      } finally {
        setLoading(false); // Stop loader
      }
    }, 0); // <-- This allows the UI to show the loader first
  };

  const handlePaymentRequestedChange = (e) => {
    const value = e.target.value;
    const paymentRequested = parseFloat(value) || 0;
    const chargesPer = parseFloat(emailDataPayLink.charges_per) || 0;
    const { paymentgatewayCharges, total_payment } = recalculateTotals(paymentRequested, chargesPer);
    setEmailDataPayLink((prev) => ({
      ...prev,
      Payment_requested: value,
      paymentgatewayCharges,
      total_payment,
    }));
  };

  const handleChargesPerChange = (e) => {
    const value = e.target.value;
    const chargesPer = parseFloat(value) || 0;
    const paymentRequested = parseFloat(emailDataPayLink.Payment_requested) || 0;
    const { paymentgatewayCharges, total_payment } = recalculateTotals(paymentRequested, chargesPer);
    setEmailDataPayLink((prev) => ({
      ...prev,
      charges_per: value,
      paymentgatewayCharges,
      total_payment,
    }));
  };


  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      {loading && (
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          zIndex: 9999,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
          <Loader />
        </div>
      )}
      <div className="mukulscode1" style={{ top: "41px" }}>

        <div className="mukulscode2">

          <h3 className="mukulscode3">Send Estimate Email with Payment Link</h3>

          <div className="row">
            <div className="col-6">
              <label className="mukulscode4">Mail To:</label>
              <input
                className="mukulscode5"
                type="text"
                value={emailDataPayLink.mail_to}
                onChange={(e) =>
                  setEmailDataPayLink({
                    ...emailDataPayLink,
                    mail_to: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-6">
              {/* Subject */}
              <label className="mukulscode4">Subject:</label>
              <input
                className="mukulscode5"
                type="text"
                value={emailDataPayLink.mail_subject}
                onChange={(e) =>
                  setEmailDataPayLink({
                    ...emailDataPayLink,
                    mail_subject: e.target.value,
                  })
                }
              />
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              {/* Payment Requested */}
              <label className="mukulscode4">Payment Requested:</label>
              <input
                className="mukulscode5"
                type="text"
                value={emailDataPayLink.Payment_requested}
                onChange={handlePaymentRequestedChange}
              />
            </div>
            <div className="col-3">
              {/* Payment Requested */}
              <label className="mukulscode4">
                Payment Gateway Charges (%):
              </label>
              <input
                className="mukulscode5"
                type="number"
                step="any"
                value={emailDataPayLink.charges_per}
                onChange={handleChargesPerChange}
              />
            </div>
            <div className="col-3">
              {/* Payment Gateway Charges */}
              <label className="mukulscode4">Payment Gateway Charges:</label>
              <label className="mukulscode12-1">
                {emailDataPayLink.paymentgatewayCharges}
              </label>
            </div>
            <div className="col-3">
              {/* Total Payment */}
              <label className="mukulscode4">Total Payment:</label>
              <label className="mukulscode14">
                {emailDataPayLink.total_payment}
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              {/* Payment Requested */}
              <label className="mukulscode4">Remark:</label>
              <input
                className="mukulscode5"
                type="text"
                value={emailDataPayLink.remark}
                onChange={(e) =>
                  setEmailDataPayLink({
                    ...emailDataPayLink,
                    remark: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-6">
              {/* Payment Requested */}
              <label className="mukulscode4">Upload Doc</label>
              <input
                className="mukulscode5"
                id="doc_name"
                type="file"
                name="doc_name"
                onChange={handleChangeDoc}
                ref={fileInputRef}
                style={{
                  paddingBottom: "0px",
                  height: "53%",
                  paddingTop: "0px",
                }}
              />
            </div>
          </div>
          <div className="mukulscode8">
            <ReactQuill
              className="mukulscode9"
              theme="snow"
              value={emailDataPayLink.mail_body}
              onChange={(value) =>
                setEmailDataPayLink({
                  ...emailDataPayLink,
                  mail_body: value,
                })
              }
              modules={{
                toolbar: [
                  [{ header: [1, 2, false] }],
                  ["bold", "italic", "underline"],
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["link"],
                  [{ align: [] }],
                  ["table"],
                ],
              }}
            />
          </div>
          {/* Buttons */}
          <div className="mukulscode15">
            <button
              className="mukulscode15-1"
              onClick={SavePdfSendMail}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Mail"}
            </button>
            <button
              className="mukulscode16"
              onClick={closeModalLink}
              style={{}}
            >
              Cancel
            </button>

          </div>
        </div>
      </div>
    </>
  );
};

export default SendMailWithPdf;
